import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import * as Table from 'reactabular-table';
import * as edit from 'react-edit';
import { each, map, trimStart, cloneDeep } from 'lodash';
import TwoElementsCell from './TwoElementsCell';
import RangeInput from './RangeInput';
import PriceInput from './PriceInput';
import Validate from './Validate';
import Headers from './SurchargeTableHeader';
const dataWithAccessorialRate = (accessorialRate) => {
    const data = {};
    const specialSurcharge = accessorialRate.special_surcharge || {};
    data.rows = [];
    const count = (specialSurcharge.weight_ranges) ? specialSurcharge.weight_ranges.length : 0;
    for (let i = 0; i < count; ++i) {
        const ratesList = map(specialSurcharge.rates, function (item) {
            if (i < item.length) {
                return item[i];
            }
        });
        let minWeight = 0;
        let maxWeight = 0;
        if (i < specialSurcharge.weight_ranges.length) {
            minWeight = specialSurcharge.weight_ranges[i][0];
            maxWeight = specialSurcharge.weight_ranges[i][1];
        }
        const row = {
            weightRange: {
                minWeight: minWeight,
                maxWeight: maxWeight,
            },
            ratesList: ratesList,
        };
        data.rows.push(row);
    }
    return data;
};
const newSurchage = () => ({
    weight_ranges: [],
    weekly_day_ranges: [[1, 5], [6, 6], [0, 0]],
    hour_ranges: [[7, 19], [0, 7], [19, 24]],
    to_index_ranges: [[0, 1], [2, 3], [4, 4]],
    rates: [],
});
const weightRangesFromData = data => map(data.rows, (row) => {
    const weightRange = row.weightRange;
    return [weightRange.minWeight, weightRange.maxWeight];
});
const ratesFromData = (data) => {
    const rates = [];
    each(data.rows, (row, rowIndex) => {
        each(row.ratesList, (rate, rateIndex) => {
            if (!rates[rateIndex]) {
                rates[rateIndex] = [];
            }
            rates[rateIndex][rowIndex] = rate;
        });
    });
    return rates;
};
const surchargeFromData = (data) => {
    const surcharge = newSurchage();
    surcharge.weight_ranges = weightRangesFromData(data);
    surcharge.rates = ratesFromData(data);
    return surcharge;
};
class AccessorialRatesSurchargeEditor extends React.Component {
    constructor(props) {
        super(props);
        this.onChangeData = (changedProperty) => {
            if (this.props.onChange) {
                this.props.onChange(changedProperty);
            }
        };
        this.createRow = (index) => {
            const dataRows = this.state.data.rows || [];
            let newRow = {};
            if (dataRows.length && index > 0 && index <= dataRows.length) {
                const lastRow = dataRows[index - 1];
                newRow = JSON.parse(JSON.stringify(lastRow));
            }
            else {
                const ratesList = [];
                each(Headers, () => {
                    ratesList.push(0);
                });
                newRow = {
                    weightRange: {
                        minWeight: 0,
                        maxWeight: 0,
                    },
                    ratesList: ratesList,
                };
            }
            return newRow;
        };
        this.addRow = () => {
            const data = this.state.data;
            const dataRows = data.rows || [];
            const index = dataRows.length;
            const newRow = this.createRow(index);
            dataRows.push(newRow);
            data.rows = dataRows;
            this.setState({ data: data });
            this.onChangeData(surchargeFromData(data));
        };
        this.insertRow = (index) => {
            const data = this.state.data;
            const dataRows = data.rows || [];
            const newRow = this.createRow(index);
            if (dataRows.length && index <= dataRows.length) {
                dataRows.splice(index, 0, newRow);
                data.rows = dataRows;
                this.setState({ data: data });
                this.onChangeData(surchargeFromData(data));
            }
        };
        this.removeRow = (index) => {
            const data = this.state.data;
            const dataRows = data.rows || [];
            if (dataRows.length && index < dataRows.length) {
                dataRows.splice(index, 1);
                data.rows = dataRows;
                this.setState({ data: data });
                this.onChangeData(surchargeFromData(data));
            }
        };
        this.tableData = () => {
            const data = this.state.data;
            const tableData = map(data.rows, function (item) {
                const row = {
                    weightRange: item.weightRange,
                    editing: item.editing,
                };
                each(item.ratesList, function (value, index) {
                    const valueKey = `Value${index + 1}`;
                    row[valueKey] = value;
                });
                return row;
            });
            return tableData;
        };
        this.tableColumns = () => {
            const formatters = (this.state) ? this.state.formatters : {};
            const data = this.state.data;
            const validators = this.state.validators;
            const editableRange = edit.edit({
                isEditing: ({ columnIndex, rowData }) => columnIndex === rowData.editing,
                onActivate: ({ columnIndex, rowIndex }) => {
                },
                onValue: ({ value, rowIndex, property }) => {
                    const dataClone = cloneDeep(this.state.data);
                    const row = dataClone.rows[rowIndex];
                    row[property] = value;
                    row.editing = false;
                    this.setState({ data: dataClone, editedKey: null });
                    this.onChangeData(surchargeFromData(dataClone));
                },
            });
            const weightRangeCell = TwoElementsCell.bind(this, 'minWeight', 'maxWeight');
            const columns = [];
            columns.push({
                property: 'weightRange',
                header: {
                    label: 'Weight Range, lbs',
                },
                cell: {
                    formatters: [
                        weightRangeCell(),
                    ],
                    transforms: [
                        editableRange(RangeInput.bind(this, 'minWeight', 'maxWeight')()),
                    ],
                },
            });
            if (data.rows) {
                const context = this;
                const dataEditable = edit.edit({
                    isEditing: ({ columnIndex, rowData }) => columnIndex === rowData.editing,
                    onActivate: ({ columnIndex, rowIndex }) => {
                        const dataClone = cloneDeep(this.state.data);
                        dataClone.rows[rowIndex].editing = columnIndex;
                        this.setState({ data: dataClone });
                    },
                    onValue: ({ value, rowIndex, property }) => {
                        const dataClone = cloneDeep(this.state.data);
                        const row = dataClone.rows[rowIndex];
                        const updatedValue = parseFloat(value);
                        const valueIndex = parseInt(trimStart(property, 'Value')) - 1;
                        row.ratesList[valueIndex] = updatedValue;
                        row.editing = false;
                        context.setState({ data: dataClone, editedKey: null });
                        this.onChangeData(surchargeFromData(dataClone));
                    },
                });
                each(Headers, (header, index) => {
                    const columnHeader = (React.createElement("div", null, header.name));
                    columns.push({
                        property: `Value${index + 1}`,
                        header: {
                            label: columnHeader,
                        },
                        cell: {
                            formatters: [
                                formatters[header.formatter],
                                validators.rates,
                            ],
                            transforms: [
                                dataEditable(PriceInput()),
                            ],
                        },
                    });
                });
                columns.push({
                    header: {
                        label: (React.createElement("div", null, "Operation")),
                    },
                    cell: {
                        formatters: [
                            (value, { rowIndex }) => {
                                const remove = () => {
                                    this.removeRow(rowIndex);
                                };
                                const insert = () => {
                                    const nextIndex = rowIndex + 1;
                                    this.insertRow(nextIndex);
                                };
                                return (React.createElement("div", null,
                                    React.createElement(ButtonGroup, { bsSize: "xsmall" },
                                        React.createElement(Button, { className: "btn btn-success", onClick: insert }, "\u271A"),
                                        React.createElement(Button, { className: "btn btn-danger", onClick: remove }, "\u2716"))));
                            },
                        ],
                    },
                });
            }
            return columns;
        };
        const formatters = {
            fixedFloat: value => parseFloat(value).toFixed(2),
            fixedInt: value => parseInt(value),
        };
        const validators = {
            rates: value => Validate(value => (value > 0))(value),
        };
        this.state = {
            accessorialRate: {},
            formatters: formatters,
            data: { rows: [] },
            editedCell: null,
            editedKey: null,
            validators: validators,
        };
    }
    componentDidMount() {
        const accessorialRate = this.props.accessorialRate;
        let data = this.state.data;
        if (accessorialRate) {
            data = dataWithAccessorialRate(accessorialRate);
            this.setState({ data: data });
        }
    }
    ;
    render() {
        const columns = this.tableColumns();
        const tableData = this.tableData();
        return (React.createElement(Table.Provider, { className: "default-table", columns: columns },
            React.createElement(Table.Header, null),
            React.createElement(Table.Body, { rows: tableData, rowKey: ({ rowIndex }) => `${rowIndex}price-table` }),
            React.createElement("tfoot", null,
                React.createElement("tr", null, columns.map((column, i) => {
                    if (i === 0) {
                        return (React.createElement("td", { key: `${i}-footer` },
                            React.createElement(Button, { bsSize: "xsmall", className: "btn btn-default", onClick: this.addRow }, "Add Row")));
                    }
                    return (React.createElement("td", { key: `${i}-footer` }));
                })))));
    }
}
AccessorialRatesSurchargeEditor.propTypes = {
    accessorialRate: PropTypes.object,
    onChange: PropTypes.func,
};
export default AccessorialRatesSurchargeEditor;
